import React from 'react';
import Icon from '../../../components/AppIcon';

const HiddenRiskDetection = ({ detections }) => {
  return (
    <div className="card bg-gradient-to-br from-card to-primary/5 shadow-xl border-2">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-2 bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent">Deteksi Risiko Tersembunyi</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Pola risiko yang teridentifikasi melalui analisis AI mendalam
          </p>
        </div>
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg animate-pulse">
          <Icon name="Eye" size={28} className="text-primary-foreground" />
        </div>
      </div>
      <div className="space-y-4">
        {detections?.map((detection) => (
          <div
            key={detection?.id}
            className="p-5 md:p-6 rounded-2xl border-2 border-border hover:border-primary transition-all duration-300 hover:shadow-2xl transform hover:scale-[1.02] bg-gradient-to-br from-card to-muted/20"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0 shadow-lg">
                <Icon name={detection?.icon} size={26} className="text-primary-foreground" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4 mb-3">
                  <h3 className="text-base md:text-lg font-bold">{detection?.pattern}</h3>
                  <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary/20 to-accent/20 border-2 border-primary/30 whitespace-nowrap shadow-md">
                    <Icon name="Brain" size={16} className="text-primary" />
                    <span className="text-xs font-bold text-primary">AI Confidence: {detection?.confidence}%</span>
                  </div>
                </div>

                <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                  {detection?.description}
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="p-4 rounded-xl bg-gradient-to-br from-muted/50 to-muted/20 border border-border shadow-inner">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Search" size={16} className="text-muted-foreground" />
                      <span className="text-xs font-bold text-muted-foreground">Sumber Data</span>
                    </div>
                    <p className="text-sm font-semibold">{detection?.dataSource}</p>
                  </div>

                  <div className="p-4 rounded-xl bg-gradient-to-br from-muted/50 to-muted/20 border border-border shadow-inner">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Target" size={16} className="text-muted-foreground" />
                      <span className="text-xs font-bold text-muted-foreground">Dampak Potensial</span>
                    </div>
                    <p className="text-sm font-semibold">{detection?.potentialImpact}</p>
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  {detection?.indicators?.map((indicator, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gradient-to-br from-warning/20 to-warning/5 border-2 border-warning/30 shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                    >
                      <Icon name="AlertCircle" size={14} className="text-warning" />
                      <span className="text-xs font-bold text-warning">{indicator}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HiddenRiskDetection;